import { Fragment } from "react";

function Setting(){
    return (
        <Fragment>
           <p>Setting</p>
        </Fragment>
    )
}
export default Setting;